if (!customElements.get('slideshow-component')) {
  customElements.define(
    'slideshow-component',
    class SlideshowComponent extends HTMLElement {
      constructor() {
        super()
        this.slidesContainer = this.querySelector('.slides')
        this.setupEventListeners()
      }
      connectedCallback() {
        this.prevButton = this.querySelector('[data-slide-prev]')
        this.nextButton = this.querySelector('[data-slide-next]')
      }
      setupEventListeners() {
        this.addEventListener('click', (e) => {
          const target = e.target
          this.slideshow = target.closest('slideshow-component')
          this.slides = this.slideshow.querySelectorAll('.slide')
          this.currentSlide =
            this.slideshow.querySelector('.slide.active').dataset.slide

          if (target.hasAttribute('data-slide-prev')) {
            const button = 'prev'
            if (parseInt(this.currentSlide) > 1) {
              this.navigate(-1, button)
            }
          }
          if (target.hasAttribute('data-slide-next')) {
            const button = 'next'
            if (parseInt(this.currentSlide) < this.slides.length) {
              this.navigate(1, button)
            }
          }
          if (target.getAttribute('data-slide')) {
            this.scrollToSlide(target)
          }
        })
      }
      updateButtonState(button) {
        if (button === 'next') {
          this.nextButton.classList.toggle(
            'disabled',
            this.currentSlide === this.slides.length
          )
        } else {
          this.prevButton.classList.toggle('disabled', this.currentSlide === 1)
        }
      }
      scrollToSlide(target) {
        let slideIndex = parseInt(target.dataset.slide)
        this.currentSlide = slideIndex
        this.slides = target.parentElement.querySelectorAll('.slide')
        this.slideshow = this

        const slideWidth = target.offsetWidth
        const scrollAmount = (slideIndex - 1) * slideWidth
        this.slidesContainer.scrollTo({
          left: scrollAmount,
          behavior: 'smooth',
        })
        this.currentSlide = slideIndex
        this.updateActiveClass(target)
      }
      navigate(direction, button) {
        let newSlide = parseInt(this.currentSlide) + parseInt(direction)

        if (newSlide < 1) {
          newSlide = this.slides.length
        } else if (newSlide > this.slides.length) {
          newSlide = 1
        }

        const targetSlide = this.slideshow.querySelector(
          `[data-slide="${newSlide}"]`
        )
        this.scrollToSlide(targetSlide)
        this.currentSlide = newSlide

        this.updateButtonState(button)
      }
      updateActiveClass(target) {
        let index = this.currentSlide
        if (typeof target === 'object') {
          index =
            parseInt(target.dataset.slideDot) || parseInt(target.dataset.slide)
        }

        this.slides.forEach((slide) => slide.classList.remove('active'))

        this.slideshow
          .querySelector(`[data-slide="${index}"]`)
          .classList.add('active')
      }
    }
  )
}
